// Wrapped rather than re-exported straight from the .svg: createIcon adds `size`, and `color` has to
// narrow to an accent role, which the ambient *.svg declaration cannot do per-folder. A plain
// annotation, not a cast — createIcon's return type is assignable to IconComponent because IconProps
// only narrows `color`.
import {createIcon} from "../icon";
import type {IconComponent} from "../icon";

import {ReactComponent as AI} from "./AI.svg";
import {ReactComponent as Add1} from "./Add1.svg";
import {ReactComponent as Add2} from "./Add2.svg";
import {ReactComponent as Back} from "./Back.svg";
import {ReactComponent as Close} from "./Close.svg";
import {ReactComponent as Cloud} from "./Cloud.svg";
import {ReactComponent as Copy} from "./Copy.svg";
import {ReactComponent as Delete} from "./Delete.svg";
import {ReactComponent as Edit} from "./Edit.svg";
import {ReactComponent as Education} from "./Education.svg";
import {ReactComponent as Export} from "./Export.svg";
import {ReactComponent as ExternalLink} from "./ExternalLink.svg";
import {ReactComponent as Eye} from "./Eye.svg";
import {ReactComponent as EyeOff} from "./EyeOff.svg";
import {ReactComponent as Fail} from "./Fail.svg";
import {ReactComponent as File} from "./File.svg";
import {ReactComponent as GetStarted} from "./GetStarted.svg";
import {ReactComponent as Import} from "./Import.svg";
import {ReactComponent as Remediate} from "./Remediate.svg";
import {ReactComponent as Restart} from "./Restart.svg";
import {ReactComponent as Search} from "./Search.svg";
import {ReactComponent as Spinner} from "./Spinner.svg";
import {ReactComponent as Star} from "./Star.svg";
import {ReactComponent as Status} from "./Status.svg";
import {ReactComponent as Success1} from "./Success1.svg";
import {ReactComponent as Success2} from "./Success2.svg";
import {ReactComponent as Time} from "./Time.svg";
import {ReactComponent as Warning} from "./Warning.svg";
import {ReactComponent as ChevronDown} from "./ChevronDown.svg";
import {ReactComponent as ChevronLeft} from "./ChevronLeft.svg";
import {ReactComponent as ChevronRight} from "./ChevronRight.svg";
import {ReactComponent as ChevronUp} from "./ChevronUp.svg";
import {ReactComponent as Error} from "./Error.svg";
import {ReactComponent as Help} from "./Help.svg";
import {ReactComponent as Info} from "./Info.svg";
import {ReactComponent as PushPin} from "./PushPin.svg";
import {ReactComponent as Revert} from "./Revert.svg";

export const AIIcon: IconComponent = createIcon(AI);
export const Add1Icon: IconComponent = createIcon(Add1);
export const Add2Icon: IconComponent = createIcon(Add2);
export const BackIcon: IconComponent = createIcon(Back);
export const CloseIcon: IconComponent = createIcon(Close);
export const CloudIcon: IconComponent = createIcon(Cloud);
export const CopyIcon: IconComponent = createIcon(Copy);
export const DeleteIcon: IconComponent = createIcon(Delete);
export const EditIcon: IconComponent = createIcon(Edit);
export const EducationIcon: IconComponent = createIcon(Education);
export const ExportIcon: IconComponent = createIcon(Export);
export const ExternalLinkIcon: IconComponent = createIcon(ExternalLink);
export const EyeIcon: IconComponent = createIcon(Eye);
export const EyeOffIcon: IconComponent = createIcon(EyeOff);
export const FailIcon: IconComponent = createIcon(Fail);
export const FileIcon: IconComponent = createIcon(File);
export const GetStartedIcon: IconComponent = createIcon(GetStarted);
export const ImportIcon: IconComponent = createIcon(Import);
export const RemediateIcon: IconComponent = createIcon(Remediate);
export const RestartIcon: IconComponent = createIcon(Restart);
export const SearchIcon: IconComponent = createIcon(Search);
export const SpinnerIcon: IconComponent = createIcon(Spinner);
export const StarIcon: IconComponent = createIcon(Star);
export const StatusIcon: IconComponent = createIcon(Status);
export const Success1Icon: IconComponent = createIcon(Success1);
export const Success2Icon: IconComponent = createIcon(Success2);
export const TimeIcon: IconComponent = createIcon(Time);
export const WarningIcon: IconComponent = createIcon(Warning);
export const ChevronDownIcon: IconComponent = createIcon(ChevronDown);
export const ChevronLeftIcon: IconComponent = createIcon(ChevronLeft);
export const ChevronRightIcon: IconComponent = createIcon(ChevronRight);
export const ChevronUpIcon: IconComponent = createIcon(ChevronUp);
export const ErrorIcon: IconComponent = createIcon(Error);
export const HelpIcon: IconComponent = createIcon(Help);
export const InfoIcon: IconComponent = createIcon(Info);
export const PushPinIcon: IconComponent = createIcon(PushPin);
export const RevertIcon: IconComponent = createIcon(Revert);
